import request from '../../../request'

export default {
  actions: {
    // list all proposals
    getProposals (_, parameters) {
      return request.get('proposals', {
        params: parameters
      })
    },

    // create new proposal
    createProposal (_, payload) {
      return request.post('proposals', payload)
    },

    // update proposal
    updateProposal (_, payload) {
      return request.put('proposals/' + payload.id, payload.proposal)
    },

    setProposalStatus(_, payload) {
      return request.post('set-proposal-status', payload);
    },

    changeProposalToIncome(_, payload) {
      return request.post('change-proposal-to-income/' + payload.id, {
        services: payload.services,
      });
    }
  }
}
